import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomer } from "../../models/Customer/Customer";

export default function useCustomer(customerId: string) {
  const { get } = useApiHelper();

  const customer = useQuery({
    queryKey: CustomerQueryKeys.single(customerId),
    queryFn: () =>
      get<IDefaultResponse<ICustomer>>(`/customer/${customerId}`).then(
        (res) => res.data,
      ),
  });

  return {
    customer,
  };
}
